var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dir-tree" },
    [
      _vm.showTitleBar
        ? _c("div", { staticClass: "title-bar" }, [
            _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "ctrl-blk" },
              [
                _vm.showFilterBox
                  ? _c("el-input", {
                      staticClass: "filter",
                      staticStyle: { width: "80px" },
                      attrs: {
                        size: "mini",
                        clearable: "",
                        placeholder: "关键字过滤"
                      },
                      on: { change: _vm.doNodeFilter },
                      model: {
                        value: _vm.filterText,
                        callback: function($$v) {
                          _vm.filterText = $$v
                        },
                        expression: "filterText"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.topActionsMaker != null
                  ? _c(
                      "span",
                      { staticStyle: { "margin-left": "4px" } },
                      _vm._l(_vm.topActionsMaker(_vm.viewMode), function(
                        action
                      ) {
                        return _c(
                          "el-link",
                          {
                            staticStyle: {
                              "margin-left": "6px",
                              "margin-right": "4px"
                            },
                            attrs: { disabled: action.disabled },
                            on: {
                              click: function($event) {
                                _vm.doTopActionCmd(action.name, action)
                              }
                            }
                          },
                          [
                            action.icon
                              ? _c(
                                  "span",
                                  {
                                    attrs: { title: action.hint || action.text }
                                  },
                                  [_c("i", { class: action.icon })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(action.text))])
                          ]
                        )
                      })
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("el-tree", {
        ref: "theTree",
        staticClass: "tree-ctrl",
        class: { noTitleBar: !_vm.showTitleBar },
        attrs: {
          expandOnClickNode: false,
          data: _vm.itemList,
          "node-key": _vm.nodeKeyProp,
          "empty-text": _vm.emptyText,
          props: _vm.treeProps,
          "default-expand-all": _vm.defaultExpandAll,
          "show-checkbox": _vm.nodeCheckable,
          "highlight-current": _vm.highlightCurrent,
          "filter-node-method": _vm.filterTreeNode,
          draggable: _vm.nodeDraggable,
          "allow-drag": _vm.allowDragJudger,
          "allow-drop": _vm.allowDropJudger
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "node-click": _vm.handleNodeClick,
          "node-drag-start": _vm.handleDragStart,
          "node-drag-enter": _vm.handleDragEnter,
          "node-drag-over": _vm.handleDragOver,
          "node-drag-leave": _vm.handleDragLeave,
          "node-drag-end": _vm.handleDragEnd,
          "node-drop": _vm.handleDrop
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var node = ref.node
              var data = ref.data
              return _c("span", { staticClass: "tree-node" }, [
                _c("span", [
                  _c("i", {
                    class: _vm.nodeClassMaker(data, node, _vm.viewMode),
                    staticStyle: { "margin-right": "4px", "font-size": "16px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "label",
                      class: {
                        current: node.isCurrent && _vm.highlightCurrent
                      },
                      attrs: { title: node.label }
                    },
                    [_vm._v(_vm._s(node.label))]
                  )
                ]),
                _vm._v(" "),
                _vm.nodeActionsMaker != null
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shouldShowNodeActions(node),
                            expression: "shouldShowNodeActions(node)"
                          }
                        ]
                      },
                      [
                        _vm.showNodeActionsAsBtns
                          ? _c(
                              "span",
                              _vm._l(
                                _vm.nodeActionsMaker(data, node, _vm.viewMode),
                                function(action) {
                                  return _c(
                                    "el-link",
                                    {
                                      staticStyle: { "margin-right": "4px" },
                                      attrs: { disabled: action.disabled },
                                      on: {
                                        click: function($event) {
                                          _vm.doNodeActionCmd(
                                            action.name,
                                            node,
                                            action
                                          )
                                        }
                                      }
                                    },
                                    [
                                      action.icon
                                        ? _c(
                                            "span",
                                            { attrs: { title: action.text } },
                                            [_c("i", { class: action.icon })]
                                          )
                                        : _c("span", [
                                            _vm._v(_vm._s(action.text))
                                          ])
                                    ]
                                  )
                                }
                              )
                            )
                          : _c("swb-ext-dropdown", {
                              attrs: {
                                dropClassName: "el-icon-s-operation",
                                items: _vm.nodeActionsMaker(
                                  data,
                                  node,
                                  _vm.viewMode
                                ),
                                data: node,
                                handler: _vm.doNodeActionCmd
                              }
                            })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15f6195c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15f6195c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ctrl/DirTree.vue
// module id = 3508
// module chunks = 1